<template>
    <v-container  grid-list-xl class="box">
        <v-layout row wrap align-center justify-center fill-height>
            <!-- filtri -->
            <v-flex xs12 sm12 md10 lg10 xl8>
            <v-row class="justify-center align-center" v-show="!$store.getters.loader && ((mapItemsCampingData && mapItemsCampingData.length > 0) && (mapItemsParkingData && mapItemsParkingData.length > 0))">
                <v-col cols="12" md="6">
                    <v-btn block :outlined="!btnFilterCamp" :color="(btnFilterCamp) ? 'info' : 'error'" @click="btnFilterCamp = !btnFilterCamp">Kampi</v-btn>
                </v-col>

                <v-col cols="12" md="6">
                    <v-btn block :outlined="!btnFilterParking" :color="(btnFilterParking) ? 'info' : 'error'" @click="btnFilterParking = !btnFilterParking">Parkirišča</v-btn>
                </v-col>
            </v-row>
            </v-flex>
            <v-flex xs12 sm12 md10 lg10 xl8  v-show="!$store.getters.loader && ((mapItemsCampingData && mapItemsCampingData.length > 0) && (mapItemsParkingData && mapItemsParkingData.length > 0))">
                <v-divider></v-divider>
            </v-flex>

            <!-- camping-->
            <v-flex xs12 sm12 md10 lg10 xl8 v-show="btnFilterCamp">
                <!--<app-page-header></app-page-header>-->
                <div v-if="mapItemsCampingData && mapItemsCampingData.length > 0">
                    <!--<v-row class="justify-center align-center" style="min-height: 100vh">-->
                        <v-row class="justify-center align-center">
                        <v-col cols="12" md="6" v-for="(camping) in mapItemsCampingData" :key="camping.uuid">
                            <CampingItem :item="camping"></CampingItem>
                        </v-col>
                    </v-row>
                </div>
                <div v-else>
                <!--<v-alert
                    v-if="search != null && search !== ''"
                    type="error"
                    prominent
                    icon="mdi-alert-circle-outline"
                    class="text-center"
                >
                    <strong>Ni najdenih kampov.</strong><br>
                    Preverite iskalni niz ali filtrirajte drugače.
                </v-alert>
                -->
                </div>
            </v-flex>

            <!-- PARKING -->
            <v-flex xs12 sm12 md10 lg10 xl8 v-if="btnFilterParking">
                <div v-if="mapItemsParkingData && mapItemsParkingData.length > 0">
                        <v-row class="justify-center align-center">
                        <v-col cols="12" md="6" v-for="(parking) in mapItemsParkingData" :key="parking.uuid">
                            <ParkingItem :item="parking"></ParkingItem>
                        </v-col>
                    </v-row>
                </div>
                <div v-else>
                <!--<v-alert
                    v-if="search != null && search !== ''"
                    type="error"
                    prominent
                    icon="mdi-alert-circle-outline"
                    class="text-center"
                >
                    <strong>Ni najdenih parkirišč.</strong><br>
                    Preverite iskalni niz ali filtrirajte drugače.
                </v-alert>-->
                </div>
            </v-flex>

            <v-flex xs12 sm12 md10 lg10 xl8>
                <v-alert
                    v-if="search != null && search !== '' && (mapItemsParkingData.length == 0 && mapItemsCampingData.length == 0)"
                    type="error"
                    prominent
                    icon="mdi-alert-circle-outline"
                    class="text-center"
                >
                    <strong>Ni najdenih zadetkov.</strong><br>
                    Preverite iskalni niz ali filtrirajte drugače.
                </v-alert>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { EventBus } from '@/main.js'
import { getCurrentDate, getCurrentTime, formatDate, isMobileDevice, getUserApplicationPermissions, checkPermissions } from '@/helpers/utilities'
const CampingItem = () => import('@/components/CampingItem.vue')
const ParkingItem = () => import('@/components/ParkingItem.vue')

export default {

    components: {
        CampingItem,
        ParkingItem
    },

    data: () => ({
        
        card1: true,
        card2: true,
        loading: false,
        search: '',

        interval1: null,
        selectedOccupancy: null,
        selectedIsOpen: null,
        occupancyItems: ['Prosto', 'Zasedeno'],
        isOpenItems: ['Obratuje', 'Ne obratuje'],

        btnFilterCamp: true,
        btnFilterParking: true
        

        
    }),

    watch: {
        searchFromStore(newValue) {
            //window.console.log(newValue)
            this.search = newValue
        },

        btnFilterCamp(value) {
            //window.console.log("btnFilterCamp: ", value)
        },

        btnFilterParking(value) {
            //window.console.log("btnFilterParking:", value)
        }
    },

    computed: {
        columnBinding() {
            const binding = {}

            if (this.$vuetify.breakpoint.mdAndDown) binding.column = true

            return binding
        },


        mapItemsCampingData() {
            //return this.$store.getters.mapItems
            const campingItems = this.$store.getters.mapItems?.camping || []

            if (!this.search || this.search.trim() === '') {
                return campingItems
            }

                const searchLower = this.search.trim().toLowerCase()

            return campingItems.filter(item =>
                item.name && item.name.toLowerCase().includes(searchLower)
            )
            
        },

        mapItemsParkingData() {
            //return this.$store.getters.mapItems
            const parkingItems = this.$store.getters.mapItems?.parking || []

            if (!this.search || this.search.trim() === '') {
                return parkingItems
            }

                const searchLower = this.search.trim().toLowerCase()

            return parkingItems.filter(item =>
                item.name && item.name.toLowerCase().includes(searchLower)
            )
            
        },

        searchFromStore: {
           get() {
               return this.$store.getters.search
           },

           set(value) {
               this.$store.commit('SET_SEARCH', this.search)
           }
       }
    },

    methods: {
    },

    created() {
        this.$store.dispatch('ROUTE_NAME', this.$route.name) 

        if(isMobileDevice(this)) {
            this.card1 = false
        }

        this.interval1 = setInterval(() => {
            this.$store.dispatch('MAP_ITEMS')
        }, 600000);

    },

    beforeDestroy() {
        clearInterval(this.interval1)
    },

    destroyed() {
        
    }
}

</script>

<style scoped>
.bg-overlay {
  background: rgba(0, 0, 0, 0.5); /* polprosojno črno ozadje */
  width: 100%;
}
</style>